import {
  ApprovalOrder,
  ApprovalPolicy,
  ApprovalStatePolicy,
} from '@/types/approvals'

type OrderRule = {
  approvalOrder: ApprovalOrder | null
  approvalsRequired: number | null
  approverCount: number
}

/** A policy's order rule in words: "In order", "All of 3", "Any 2 of 3". */
export function orderRuleLabel({
  approvalOrder,
  approvalsRequired,
  approverCount,
}: OrderRule): string {
  if (approvalOrder === 'sequential') return 'In order'
  return approvalsRequired === null
    ? `All of ${approverCount}`
    : `Any ${approvalsRequired} of ${approverCount}`
}

/** Wrapper for the `orderRuleLabel` function to return it in uppercase. */
export function orderChipLabel(policy: ApprovalStatePolicy): string | null {
  if (!policy.config_resolved) return null
  return orderRuleLabel({
    approvalOrder: policy.approval_order,
    approvalsRequired: policy.approvals_required,
    approverCount: policy.approvers.length,
  }).toUpperCase()
}

export function policyOrderChipLabel(policy: ApprovalPolicy): string {
  return orderRuleLabel({
    approvalOrder: policy.approval_order,
    approvalsRequired: policy.approvals_required,
    approverCount: policy.approvers.length,
  }).toUpperCase()
}
